import { render, staticRenderFns } from "./detailModal.vue?vue&type=template&id=2ff352fa&scoped=true"
import script from "./detailModal.vue?vue&type=script&lang=js"
export * from "./detailModal.vue?vue&type=script&lang=js"
import style0 from "./detailModal.vue?vue&type=style&index=0&id=2ff352fa&prod&lang=css"
import style1 from "./detailModal.vue?vue&type=style&index=1&id=2ff352fa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff352fa",
  null
  
)

export default component.exports